export const WARNING_LEVEL_DICT = {
    1: '二',
    2: '三',
    3: '四',
}

export function getWarningLevelName(value: number) {
    if (value === 0) {
        return '安全';
    } else if (value === 1) {
        return '二级';
    } else if (value === 2) {
        return '三级';
    } else if (value === 3) {
        return '四级';
    }
    return '';
}

export const WARNING_LEVEL = {
    NONE: 0,
    T2: 1,
    T3: 2,
    T4: 3,
}